
import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../css/HomeVideo.css";

const VideoSection = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
    }
  }, []);

  return (
    <section className="home-video-container">
      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 5000, // Image stays for 5 seconds
          disableOnInteraction: false,
        }}
        loop={true}
        pagination={{ clickable: true }}
        className="home-swiper"
        onSlideChange={(swiper) => {
          if (swiper.activeIndex === 1 && videoRef.current) {
            swiper.params.autoplay.delay = 50000; // Video stays for 10 seconds
            videoRef.current.play();
          } else {
            swiper.params.autoplay.delay = 50000;
          }
        }}
      >
        {/* Slide 1: Image */}
        <SwiperSlide>
          <div className="slide-wrapper">
            <picture>
              <source srcSet="/images/Mobile-HomeBanner-Dr-Check.png" media="(max-width: 468px)" />
              <img
                src="/images/Desktop-Home-Banner-Dr-Check.webp"
                alt="Dr. Chek"
                className="home-image"
              />
            </picture>
          </div>
        </SwiperSlide>

        {/* Slide 2: Video with Text */}
        <SwiperSlide>
          <div className="slide-wrapper">
            <video
              ref={videoRef}
              className="home-video"
              loop
              muted
              playsInline
              preload="auto"
            >
              <source
                src="/Dr chek.mp4"
                type="video/mp4"
                media="(max-width: 768px)"
              />
              <source src="/Dr chek.mp4" type="video/mp4" media="(min-width: 769px)" />
              Your browser does not support the video tag.
            </video>

            {/* Text Content on Video */}
            <div className="video-content">
              <h1 className="video-title1">Dr.Chek</h1>
              <h2 className="video-heading">
                Reliable Monitoring for<br /> a Healthier Life
              </h2>
              <a href="/products">
                <button className="video-btn">Our Products</button>
              </a>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default VideoSection;
